export default __webpack_public_path__ + "static/ombralsun-1-0afd83de48335459401f2a694f1eccd0.jpg";